<div class="modal-etapa">
  <div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined" [style.color]="cor">{{ icone }}</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h2 class="modal-title">{{ nome || 'Informe o nome da etapa' }}</h2>
      <p class="modal-subtitle">{{ isNova ? 'Nova etapa' : 'Editar etapa' }}</p>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
        (click)="fechar()">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="modal-content">

    @if (isCarregando) {
    <div class="modal-loading">
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
    </div>
    } @else {

    <!-- 1. Identidade -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">1</span>
        <mat-icon class="material-symbols-outlined">badge</mat-icon>
        <span>Identidade</span>
      </div>
      <p class="section-sub-title">Como esta etapa aparece no board operacional.</p>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Nome da etapa</mat-label>
        <input matInput [(ngModel)]="nome" [disabled]="isNomeBloqueado" placeholder="Ex.: Solicitação de Compra" />
        @if (isNomeBloqueado) {
        <mat-icon matSuffix class="material-symbols-outlined nome-lock" matTooltip="Etapa padrão: nome bloqueado">lock</mat-icon>
        }
      </mat-form-field>

      <div class="grid-2">
        <div>
          <span class="k-label">Cor</span>
          <div class="swatch-box">
            @for (c of cores; track c) {
            <button type="button" class="swatch" [class.swatch--active]="cor === c" [style.background-color]="c"
              (click)="selecionarCor(c)" [matTooltip]="c"></button>
            }
          </div>
        </div>
        <div>
          <span class="k-label">Ícone</span>
          <div class="swatch-box">
            @for (ic of icones; track ic) {
            <button type="button" class="icon-swatch" [class.icon-swatch--active]="icone === ic"
              (click)="selecionarIcone(ic)" [matTooltip]="ic">
              <mat-icon class="material-symbols-outlined">{{ ic }}</mat-icon>
            </button>
            }
          </div>
        </div>
      </div>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Descrição interna</mat-label>
        <textarea matInput rows="2" [(ngModel)]="descricao"
          placeholder="Explique brevemente o que acontece nesta etapa."></textarea>
        <mat-hint>Tooltip de ajuda exibida ao operador no board</mat-hint>
      </mat-form-field>

      @if (isConferencia) {
      <div class="conf-block sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
          <span>Específico da conferência física</span>
        </div>

        <!-- Volumes antes de itens: é a ordem do processo físico — o volume chega e é recebido
             antes de os itens dentro dele serem conferidos. -->
        <div class="k-label">Modo de conferência — recebimento (volumes)</div>
        <p class="sub-section-sub-title">
          Define se o operador verá ou não as quantidades esperadas ao contar os volumes.
        </p>
        <div class="grid-2">
          <button type="button" class="conf-opt" [class.conf-opt--active]="modoVolumes === TipoConferenciaEnum.Aberta"
            (click)="modoVolumes = TipoConferenciaEnum.Aberta">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">visibility</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Aberto</strong>
              <small>Quantidades esperadas visíveis para o conferente.</small>
            </span>
          </button>
          <button type="button" class="conf-opt" [class.conf-opt--active]="modoVolumes === TipoConferenciaEnum.Cega"
            (click)="modoVolumes = TipoConferenciaEnum.Cega">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">visibility_off</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Cego</strong>
              <small>Quantidades esperadas ocultas — reduz viés do conferente.</small>
            </span>
          </button>
        </div>

        <div class="k-label">Modo de conferência — itens</div>
        <p class="sub-section-sub-title">
          Define se o operador verá ou não as quantidades esperadas extraídas da NF ao contar os itens.
        </p>
        <div class="grid-2">
          <button type="button" class="conf-opt" [class.conf-opt--active]="modoItens === TipoConferenciaEnum.Aberta"
            (click)="modoItens = TipoConferenciaEnum.Aberta">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">visibility</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Aberto</strong>
              <small>Quantidades esperadas visíveis para o conferente.</small>
            </span>
          </button>
          <button type="button" class="conf-opt" [class.conf-opt--active]="modoItens === TipoConferenciaEnum.Cega"
            (click)="modoItens = TipoConferenciaEnum.Cega">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">visibility_off</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Cego</strong>
              <small>Quantidades esperadas ocultas — reduz viés do conferente.</small>
            </span>
          </button>
        </div>
      </div>
      }

      @if (isPedidoFaturado) {
      <div class="conf-block sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">fact_check</mat-icon>
          <span>Específico do confronto NF × Pedido</span>
        </div>

        <div class="k-label">Produtos não cadastrados no Pedido de Compra</div>
        <p class="sub-section-sub-title">
          A NF traz um item que não existe no Pedido de Compra (extra, não previsto na compra original).
        </p>
        <div class="grid-2">
          <button type="button" class="conf-opt" [class.conf-opt--active]="regraProdutoNaoCadastrado === TipoRegraConfrontoEnum.Avisar"
            (click)="regraProdutoNaoCadastrado = TipoRegraConfrontoEnum.Avisar">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">info</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Avisar</strong>
              <small>Sinaliza o item extra, mas deixa concluir a conciliação.</small>
            </span>
          </button>
          <button type="button" class="conf-opt" [class.conf-opt--active]="regraProdutoNaoCadastrado === TipoRegraConfrontoEnum.Proibir"
            (click)="regraProdutoNaoCadastrado = TipoRegraConfrontoEnum.Proibir">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">block</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Proibir</strong>
              <small>Bloqueia a conciliação enquanto o item extra não for tratado.</small>
            </span>
          </button>
        </div>

        <div class="k-label">% de tolerância sobre o preço dos produtos do Pedido de Compra</div>
        <p class="sub-section-sub-title">
          Diferença entre o preço do item no Pedido e o preço do mesmo item na NF.
        </p>
        <div class="grid-2">
          <button type="button" class="conf-opt" [class.conf-opt--active]="regraToleranciaPreco === TipoRegraConfrontoEnum.Avisar"
            (click)="regraToleranciaPreco = TipoRegraConfrontoEnum.Avisar">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">info</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Avisar</strong>
              <small>Sinaliza o item fora da tolerância e pede a decisão (aceitar e ajustar ou marcar divergência), mas deixa concluir.</small>
            </span>
          </button>
          <button type="button" class="conf-opt" [class.conf-opt--active]="regraToleranciaPreco === TipoRegraConfrontoEnum.Proibir"
            (click)="regraToleranciaPreco = TipoRegraConfrontoEnum.Proibir">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">block</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Proibir</strong>
              <small>Bloqueia o vínculo enquanto o preço estiver fora da tolerância.</small>
            </span>
          </button>
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="conf-tol">
          <mat-label>Tolerância de preço (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" [(ngModel)]="toleranciaPreco" />
          <mat-hint>Até este percentual o vínculo passa; acima, vale a regra escolhida.</mat-hint>
        </mat-form-field>

        <div class="k-label">% de tolerância sobre a quantidade dos produtos do Pedido de Compra</div>
        <p class="sub-section-sub-title">
          Diferença entre a quantidade do item no Pedido e a quantidade na NF (a nota cobrindo mais do que o
          pedido).
        </p>
        <div class="grid-2">
          <button type="button" class="conf-opt" [class.conf-opt--active]="regraToleranciaQuantidade === TipoRegraConfrontoEnum.Avisar"
            (click)="regraToleranciaQuantidade = TipoRegraConfrontoEnum.Avisar">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">info</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Avisar</strong>
              <small>Sinaliza o item fora da tolerância e pede a decisão (aceitar e ajustar ou marcar divergência), mas deixa concluir.</small>
            </span>
          </button>
          <button type="button" class="conf-opt" [class.conf-opt--active]="regraToleranciaQuantidade === TipoRegraConfrontoEnum.Proibir"
            (click)="regraToleranciaQuantidade = TipoRegraConfrontoEnum.Proibir">
            <span class="conf-opt-icon"><mat-icon class="material-symbols-outlined">block</mat-icon></span>
            <span class="conf-opt-text">
              <strong>Proibir</strong>
              <small>Bloqueia o vínculo enquanto a quantidade estiver fora da tolerância.</small>
            </span>
          </button>
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="conf-tol">
          <mat-label>Tolerância de quantidade (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" [(ngModel)]="toleranciaQuantidade" />
          <mat-hint>Até este percentual o vínculo passa; acima, vale a regra escolhida.</mat-hint>
        </mat-form-field>
      </div>
      }

      @if (isCancelado) {
      <div class="conf-block sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
          <span>Específico do cancelamento</span>
        </div>

        <p class="sub-section-sub-title">
          Cancelar o pedido libera a NF-e vinculada para a Gaveta de NFs.
        </p>
      </div>
      }

      <!-- Somente leitura: o disparo é fixo nesta etapa; ativação e origem vêm das automações de compras.
           Sem a permissão de um lançamento ativo o movimento é recusado (HU-003 CA 14). -->
      @if (isFinalizado) {
      <div class="conf-block sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">bolt</mat-icon>
          <span>Integrações disparadas nesta etapa</span>
        </div>

        <app-alert-card type="success" icon="flag" title="Estoque e financeiro são lançados aqui">
          <p class="integracao-texto">
            Quando o card chega em <strong>Finalizado</strong>, só são disparados os lançamentos ativos nas automações
            <strong>Lançar estoque</strong> e <strong>Lançar financeiro</strong>. A ativação e a origem (Pela Nota Fiscal
            ou Pelo Pedido) são configuradas em <strong>Automações de compras</strong>; lançamento desativado não é
            gerado pelo Kanban. É sempre esta etapa: não há como mover o disparo para outra.
          </p>
          @if (lancamentosFinalizado) {
          <div class="integracao-chips">
            @for (lancamento of lancamentosFinalizado; track lancamento.nome) {
            <span class="status-badge" [class.badge-verde]="lancamento.ativo" [class.badge-cinza]="!lancamento.ativo">
              <mat-icon class="material-symbols-outlined">{{ lancamento.icone }}</mat-icon>
              {{ lancamento.nome }} · {{ !lancamento.ativo ? 'Desativado'
                : lancamento.idOrigemLancamento === OrigemLancamentoEnum.Pedido ? 'Pelo Pedido' : 'Pela Nota Fiscal' }}
            </span>
            }
          </div>
          }
          <p class="integracao-rodape">
            Com lançamento ativo, o perfil precisa da permissão <strong>Inserir</strong> do Processo de Compras para
            entrar em Finalizado. Sem ela, o card não entra em Finalizado; lançamento desativado não exige permissão.
          </p>
        </app-alert-card>
      </div>
      }
    </section>

    <!-- 2. Campos da etapa -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">2</span>
        <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
        <span>Campos da etapa</span>
      </div>
      <p class="section-sub-title">Informações que o card deve receber enquanto estiver nesta etapa.</p>

      @if (camposNativos.length > 0) {
      <div class="campos-nativos sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">database</mat-icon>
          <span>Campos nativos da compra</span>
        </div>
        @for (cn of camposNativos; track cn.idCampoNativo) {
        <div class="campo-nativo-row">
          <mat-icon class="material-symbols-outlined campo-nativo-lock" matTooltip="Campo nativo da compra">lock</mat-icon>
          <span class="campo-nativo-nome">{{ cn.nome }}</span>
          <span class="spacer"></span>
          <div class="campo-obrigatorio">
            <mat-slide-toggle class="app-toggle-compact" color="primary" [(ngModel)]="cn.obrigatorio">
              Obrigatório
            </mat-slide-toggle>
          </div>
        </div>
        }
      </div>
      }

      <div class="campos-personalizados sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">tune</mat-icon>
          <span>Campos personalizados</span>
          <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" (click)="adicionarCampo()">
              <mat-icon class="material-symbols-outlined">add</mat-icon>
              Adicionar campo
            </button>
          </div>
        </div>

        @if (campos.length === 0) {
        <app-empty-state icon="list_alt" title="Nenhum campo personalizado"
          subtitle="Os cards desta etapa terão apenas os campos nativos e globais."></app-empty-state>
        }

        <div class="campos-list" cdkDropList (cdkDropListDropped)="reordenarCampos($event)">
        @for (campo of campos; track $index) {
        <div class="campo-row" [class.campo-row--nativo]="!!campo.isNativo" cdkDrag [cdkDragDisabled]="!!campo.isNativo">
          <span class="campo-handle" cdkDragHandle
            [matTooltip]="campo.isNativo ? 'Campo nativo da compra' : 'Arraste para reordenar'">
            @if (campo.isNativo) {
            <mat-icon class="material-symbols-outlined">lock</mat-icon>
            } @else {
            <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
            }
          </span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-nome">
            <input matInput [(ngModel)]="campo.nome" [readonly]="!!campo.isNativo" placeholder="Nome do campo" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-tipo">
            <mat-select [(ngModel)]="campo.tipo" [disabled]="!!campo.isNativo" (ngModelChange)="onTipoCampoChange(campo)">
              @for (t of tiposCampo; track t.id) {
              <mat-option [value]="t.id">{{ t.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="campo-obrigatorio">
            <mat-slide-toggle class="app-toggle-compact" color="primary" [(ngModel)]="campo.obrigatorio">
              Obrigatório
            </mat-slide-toggle>
          </div>
          @if (campo.isNativo) {
          <span class="campo-action-spacer" matTooltip="Campo nativo"></span>
          } @else {
          <button mat-icon-button type="button" matTooltip="Remover" (click)="removerCampo($index)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
          }
          @if (isCampoComOpcoes(campo)) {
          <div class="campo-opcoes">
            <div class="campo-opcoes-head">
              <span>Opções do dropdown</span>
              @if (!campo.isNativo) {
              <button mat-stroked-button type="button" class="campo-opcao-add" (click)="adicionarOpcao(campo)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                Adicionar opção
              </button>
              }
            </div>
            <div class="campo-opcoes-list">
              @for (opcao of campo.opcoes; track $index) {
              <div class="campo-opcao-row">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-opcao-input">
                  <input matInput [(ngModel)]="opcao.descricao" [readonly]="!!campo.isNativo"
                    [placeholder]="'Opção ' + ($index + 1)" />
                </mat-form-field>
                @if (!campo.isNativo) {
                <button mat-icon-button type="button" matTooltip="Remover opção" (click)="removerOpcao(campo, $index)">
                  <mat-icon class="material-symbols-outlined">close</mat-icon>
                </button>
                }
              </div>
              }
            </div>
          </div>
          }
          @if (isCampoVinculo(campo)) {
          <div class="campo-opcoes">
            <div class="campo-opcoes-head">
              <span>Entidade vinculada</span>
            </div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-vinculo">
              <mat-select [(ngModel)]="campo.vinculo" [disabled]="!!campo.isNativo">
                @for (v of vinculoEntidades; track v.value) {
                <mat-option [value]="v.value">{{ v.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
        </div>
        }
        </div>
      </div>

    </section>

    <!-- 3. Movimentações permitidas -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">3</span>
        <mat-icon class="material-symbols-outlined">moving</mat-icon>
        <span>Movimentações permitidas</span>
      </div>
      <p class="section-sub-title">Marque para quais destinos o card pode ir a partir desta etapa.</p>

      <app-alert-card type="warning" icon="moving">
        <span>
          A partir de <strong>{{ nome || 'esta etapa' }}</strong>, o card pode ir para
          <strong>{{ totalDestinos }} {{ totalDestinos === 1 ? 'destino' : 'destinos' }}</strong>.
        </span>
      </app-alert-card>

      <!-- Os níveis decidem quais destinos abaixo ficam disponíveis. -->
      <div class="nivel-grid">
        <div>
          <span class="nivel-label">
            Dados garantidos ao sair desta etapa
            @if (isNiveisBloqueados) {
            <mat-icon class="material-symbols-outlined nivel-lock" matTooltip="Etapa padrão: níveis bloqueados">lock</mat-icon>
            }
          </span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
            <mat-select [(ngModel)]="nivelGarantido" [disabled]="isNiveisBloqueados"
              (ngModelChange)="onNivelGarantidoChange()">
              @for (n of niveis; track n.idNivelDadosCompra) {
              <mat-option [value]="n.idNivelDadosCompra">{{ n.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p class="nivel-hint">Limita para onde o card pode ir a partir daqui.</p>
        </div>
        <div>
          <span class="nivel-label">
            Dados exigidos para entrar nesta etapa
            @if (isNiveisBloqueados) {
            <mat-icon class="material-symbols-outlined nivel-lock" matTooltip="Etapa padrão: níveis bloqueados">lock</mat-icon>
            }
          </span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
            <mat-select [(ngModel)]="nivelRequisito" [disabled]="isNiveisBloqueados">
              @for (n of niveis; track n.idNivelDadosCompra) {
              <mat-option [value]="n.idNivelDadosCompra">{{ n.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p class="nivel-hint">Impede que outras etapas mandem cards para cá antes disso.</p>
        </div>
      </div>

      @if (etapasPrincipaisDestino.length > 0) {
      <div class="sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">route</mat-icon>
          <span>Fluxo de compras</span>
        </div>
        <div class="dest-list">
          @for (d of etapasPrincipaisDestino; track d.etapa.idEtapaKanban) {
          <ng-container *ngTemplateOutlet="destinoRow; context: { d: d }"></ng-container>
          }
        </div>
      </div>
      }

      @if (etapasEspeciaisDestino.length > 0) {
      <div class="sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">alt_route</mat-icon>
          <span>Estados especiais</span>
        </div>
        <div class="dest-list">
          @for (d of etapasEspeciaisDestino; track d.etapa.idEtapaKanban) {
          <ng-container *ngTemplateOutlet="destinoRow; context: { d: d }"></ng-container>
          }
        </div>
      </div>
      }

    </section>

    <!-- 4. Condições de aprovação (somente Aprovação) -->
    @if (isAprovacao) {
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">4</span>
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>Condições de aprovação</span>
        <div class="section-title-actions ms-auto">
          <button mat-button type="button" class="btn-section" (click)="adicionarFaixa()">
            <mat-icon class="material-symbols-outlined">add</mat-icon>
            Adicionar faixa
          </button>
        </div>
      </div>
      <p class="section-sub-title">Quantos aprovadores e as faixas de valor que definem quem aprova.</p>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="aprov-count">
        <mat-label>Aprovações necessárias</mat-label>
        <input matInput type="text" inputmode="numeric" [currencyMask]="integerMask" [(ngModel)]="aprovadoresNecessarios" />
      </mat-form-field>

      <div class="faixas-list">
        @for (faixa of faixas; track faixa.id; let i = $index) {
        <div class="faixa-card">
          <div class="faixa-top">
            <div>
              <span class="k-mini-label">Faixa</span>
              <div class="faixa-resumo">{{ resumoFaixa(faixa, i) }}</div>
            </div>
            <div class="faixa-limites">
              <span class="k-mini-label">Limites</span>
              <div class="faixa-inputs">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Mínimo</mat-label>
                  <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" [(ngModel)]="faixa.min" />
                </mat-form-field>
                <span class="faixa-seta">→</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Máximo</mat-label>
                  <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" [(ngModel)]="faixa.max"
                    [disabled]="faixa.max === null" [placeholder]="faixa.max === null ? '∞' : ''" />
                </mat-form-field>
              </div>
            </div>
            <button mat-icon-button type="button" matTooltip="Remover faixa" [disabled]="faixas.length <= 1"
              (click)="removerFaixa(faixa.id)">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
            </button>
          </div>
          <div class="faixa-perfis">
            <span class="k-mini-label">Perfis que podem aprovar</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-select [(ngModel)]="faixa.perfis" multiple placeholder="Aprovação automática (não exige)">
                @for (p of perfis; track p.idPerfil) {
                <mat-option [value]="p.idPerfil">{{ p.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-checkbox class="faixa-notificar" color="primary" [(ngModel)]="faixa.notificar"
              [disabled]="!notificacaoDisponivel(faixa)"
              [matTooltip]="notificacaoDisponivel(faixa) ? '' : 'A faixa não exige aprovação'">
              Notificar os perfis que podem aprovar
            </mat-checkbox>
          </div>
        </div>
        }
      </div>

    </section>
    }

    <!-- Permissões por perfil -->
    <section class="section-container">
      <!-- A seção de aprovação só existe na etapa de aprovação; sem ela a numeração pularia o 4. -->
      <div class="section-title">
        <span class="status-badge badge-cinza">{{ isAprovacao ? 5 : 4 }}</span>
        <mat-icon class="material-symbols-outlined">lock_person</mat-icon>
        <span>Permissões por perfil</span>
      </div>
      <p class="section-sub-title">Quem pode fazer o quê nesta etapa.</p>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Filtrar perfil</mat-label>
        <mat-icon matIconPrefix class="material-symbols-outlined">search</mat-icon>
        <input matInput [(ngModel)]="filtroPerfil" placeholder="Filtrar perfil…" />
      </mat-form-field>

      <div class="matriz">
        <div class="matriz-head" [style.grid-template-columns]="'minmax(120px,1.5fr) repeat(' + acoesVisiveis.length + ', 1fr)'">
          <div class="matriz-th">Perfil</div>
          @for (a of acoesVisiveis; track a.id) {
          <div class="matriz-th matriz-th--acao" (click)="toggleColuna(a.id)">
            <mat-icon class="material-symbols-outlined">{{ a.icon }}</mat-icon>
            <span>{{ a.label }}</span>
            <mat-checkbox color="primary" [checked]="estadoColuna(a.id) === 'all'"
              [indeterminate]="estadoColuna(a.id) === 'some'" (change)="toggleColuna(a.id)"
              (click)="$event.stopPropagation()"></mat-checkbox>
          </div>
          }
        </div>
        @for (p of perfisFiltrados; track p.idPerfil) {
        <div class="matriz-row" [style.grid-template-columns]="'minmax(120px,1.5fr) repeat(' + acoesVisiveis.length + ', 1fr)'">
          <div class="matriz-perfil">
            <mat-icon class="material-symbols-outlined">shield_person</mat-icon> {{ p.nome }}
          </div>
          @for (a of acoesVisiveis; track a.id) {
          <div class="matriz-cell">
            <mat-checkbox color="primary" [checked]="!!permissoes[p.idPerfil]?.[a.id]"
              (change)="togglePermissao(p.idPerfil, a.id)"></mat-checkbox>
          </div>
          }
        </div>
        } @empty {
        <app-empty-state icon="shield_person" title="Nenhum perfil encontrado"
          [subtitle]="filtroPerfil ? 'Ajuste o filtro de perfil.' : ''"></app-empty-state>
        }
      </div>

      <p class="matriz-hint">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        Perfis sem <strong>Visualizar</strong> não enxergam os cards desta etapa no board.
      </p>
    </section>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer">
    @if (!isNova) {
    <span class="tooltip-wrap" matTooltip="Etapa padrão do sistema não pode ser excluída"
      [matTooltipDisabled]="!isEtapaPadrao">
      <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isEtapaPadrao || isSalvando"
        (click)="excluir()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon> Excluir etapa
      </button>
    </span>
    }
    <span class="spacer"></span>
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()" [disabled]="isSalvando">Cancelar</button>
    <span class="tooltip-wrap" matTooltip="A configuração da etapa não foi carregada. Feche e abra o cadastro novamente."
      [matTooltipDisabled]="isCarregando || configCarregada">
      <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isSalvando"
        [disabled]="isCarregando || isSalvando || !configCarregada"
        [attr.aria-label]="isSalvando ? 'Salvando' : 'Salvar etapa'" (click)="salvar()">
        <mat-icon class="material-symbols-outlined">check</mat-icon> Salvar etapa
        @if (isSalvando) { <mat-spinner diameter="20"></mat-spinner> }
      </button>
    </span>
  </mat-dialog-actions>
</div>

<!-- Linha de destino reaproveitada -->
<ng-template #destinoRow let-d="d">
  <div class="dest-row" [class.dest-row--sel]="d.config.selecionado"
    [class.dest-row--bloq]="destinoBloqueado(d)">
    <label class="dest-head" [matTooltip]="destinoBloqueado(d) ? motivoBloqueio(d) : ''">
      <span class="dest-icone" [style.background-color]="d.etapa.tint" [style.border-color]="d.etapa.cor"
        [style.color]="d.etapa.cor">
        <mat-icon class="material-symbols-outlined">{{ d.etapa.icone }}</mat-icon>
      </span>
      <span class="dest-nome">{{ d.etapa.nome }}</span>
      @if (d.etapa.isFinal) {
      <span class="status-badge badge-cinza">Final</span>
      }
      <span class="spacer"></span>
      @if (destinoBloqueado(d)) {
      <mat-icon class="material-symbols-outlined dest-bloq-ico">lock</mat-icon>
      }
      @if (d.etapa.isEspecial) {
      <span class="status-badge badge-vermelho">Especial</span>
      }
      <!-- O <label> já toga o checkbox nativo em qualquer clique na linha,
           não importa a posição dele dentro do label. -->
      <mat-checkbox color="primary" [(ngModel)]="d.config.selecionado"
        [disabled]="destinoBloqueado(d)"></mat-checkbox>
    </label>
    @if (d.config.selecionado && !destinoBloqueado(d)) {
    <div class="dest-perfis">
      <span class="dest-perfis-label">
        <mat-icon class="material-symbols-outlined">lock_person</mat-icon> Perfis autorizados a mover
      </span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-select [(ngModel)]="d.config.perfis" multiple placeholder="Todos os perfis podem mover">
          @for (p of perfis; track p.idPerfil) {
          <mat-option [value]="p.idPerfil">{{ p.nome }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="dest-perfis-chips">
        @for (idPerfil of d.config.perfis; track idPerfil) {
        <app-ui-tag [text]="nomePerfil(idPerfil)" colorClass="badge-cinza" [closable]="true"
          (remove)="removerPerfilDestino(d, idPerfil)"></app-ui-tag>
        }
      </div>
      <mat-checkbox class="dest-justificativa" color="primary" [(ngModel)]="d.config.exigeJustificativa">
        Exigir justificativa ao mover para {{ d.etapa.nome }}
      </mat-checkbox>
    </div>
    }
  </div>
</ng-template>
